export default "__VITE_ASSET__BVtmC_jI__"